<template>
  <van-popup v-model="show" get-container="#app" position="bottom" round @click-overlay="closePop">
    <div class="pop_title">
      <div class="title_close" @click="closePop">取消</div>
      <div class="title_center">选择请假时间段</div>
      <div class="title_confirm" @click="handleConfirm">确定</div>
    </div>

    <div class="pop_tabs">
      <div :class="type == 1 ? 'pop_tabs_item pop_tabs_item_active' : 'pop_tabs_item'" @click="changeStartEndDate(1)">
        <div class="tabs_item_title">开始时间</div>
        <div class="tabs_item_date">{{ `${nowSelectStartDate ? nowSelectStartDate : '- 年 - 月 -日'}` }} {{
    `${nowSelectStartTime ? nowSelectStartTime : '---'}` }}</div>
      </div>
      <div :class="type == 2 ? 'pop_tabs_item pop_tabs_item_active' : 'pop_tabs_item'" @click="changeStartEndDate(2)">
        <div class="tabs_item_title">结束时间</div>
        <div class="tabs_item_date">{{ `${nowSelectEndDate ? nowSelectEndDate : '- 年 - 月 -日'}` }} {{ `${nowSelectEndTime
    ?
    nowSelectEndTime : '---'}` }}</div>
      </div>
    </div>
    <!-- 时间选择 -->
    <div class="date_change">
      <div class="date_change_left">

        <!-- 班主任请假不能请当前时间之前的假 -->
        <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
          v-if="identity == 'teacher'">
          <div @click="selectDate(item)"
            :class="getMomentDate(item) == getMomentDate(nowSelectDate) ? 'left_item left_item_active' : 'left_item'"
            v-for="(item, index) in timeArr" :key="index">{{ getListDate(item) }}</div>
        </van-list>
        <!-- 宿管可以请当前时间之前的假 -->
        <van-pull-refresh v-model="prevLoading" loosing-text="获取日期" @refresh="getPrevDateList" v-else>
          <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <div @click="selectDate(item)"
              :class="getMomentDate(item) == getMomentDate(nowSelectDate) ? 'left_item left_item_active' : 'left_item'"
              v-for="(item, index) in timeArr" :key="index">{{ getListDate(item) }}</div>
          </van-list>
        </van-pull-refresh>
      </div>

      <div class="date_change_right">
        <!-- 选择时间类型 -->
        <div class="date_change_type">

          <!-- 时间选择类型 -->
          <div class="type_checkbox">
            <van-checkbox @click="changeType(1)" class="dorm-name-right-check" shape="square" icon-size="11px"
              :value="dateChangeType == 1">按时段</van-checkbox>
          </div>

          <!-- 时间选择类型  -->
          <div class="type_checkbox">
            <van-checkbox @click="changeType(2)" class="dorm-name-right-check" shape="square" icon-size="11px"
              :value="dateChangeType == 2">自定义</van-checkbox>
          </div>
        </div>

        <!-- 展示时段 -->
        <div class="date_change_timeList" v-if="dateChangeType == 1">

          <template v-for="(item,index) in timeTypeList" >
            <div :class="selectTimeType == item.timeType && isChecked(item.startTime) ? 'typeList_item typeList_item_active' : 'typeList_item'" 
            @click="handleStartTimetype(item)">
              <span> {{ ['', '早离寝', '午归寝', '午离寝', '晚归寝'][item.timeType] }}时段 {{ ['', '开始', '结束'][1] }}时间（{{getDate(item.startTime) }}）</span>
              <van-checkbox v-if="selectTimeType == item.timeType && isChecked(item.startTime)" class="custom-checkbox" icon-size="16px" :value="true" />
            </div>


            <div :class="selectTimeType == item.timeType && isChecked(item.endTime) ? 'typeList_item typeList_item_active' : 'typeList_item'" 
            @click="handleEndTimetype(item)">
              <span> {{ ['', '早离寝', '午归寝', '午离寝', '晚归寝'][item.timeType] }}时段 {{ ['', '开始', '结束'][2] }}时间（{{ getDate(item.endTime) }}）</span>
              <van-checkbox v-if="selectTimeType == item.timeType && isChecked(item.endTime)" class="custom-checkbox" icon-size="16px" :value="true" />
            </div>
          </template>

        </div>

        <div class="date_change_timeList date_picker" v-if="dateChangeType == 2">
          <!-- 展示时间选取 根据老师或宿管身份进行筛选 -->
          <van-datetime-picker :min-hour="minHour" :max-hour="maxHour" :min-minute="minMinute" :max-minute="maxMinute"
            @change="handleDatePicker" item-height="2.3438rem" class="datetime_picker" :show-toolbar="false"
            v-model="currentTime" type="time" />
        </div>

      </div>
    </div>
  </van-popup>
</template>

<script>
import moment from 'moment';
export default {
  props: {
    personList: {
      type: Array,
      default: []
    },
    selectFloor: {
      type: String,
      default: ''
    },

    // 判断当前是班主任请假还是宿舍管理员请假
    identity: {
      type: String,
      default: 'teacher' // 默认宿管身份
    }
  },
  components: {

  },
  data() {
    return {
      // 默认选择的是开始还是结束时间
      activeKey: '',

      // 时间类型选择
      dateChangeType: 1,

      // 开始|| 结束时间选择
      type: 1,

      // 弹窗展示
      show: false,
      // 当前时间
      currentTime: moment().format('HH:mm:ss'),
      // 已选中的左侧日期
      nowSelectDate: moment(),
      // 选择时段类型
      selectTimeType: '',

      timeTypeList: [],



      // 选中的开始日期
      nowSelectStartDate: '',
      // 选中的开始时间
      nowSelectStartTime: '',
      // 选中的结束日期
      nowSelectEndDate: '',
      // 选中的结束时间
      nowSelectEndTime: '',

      // 开始时间选择的时间类型
      nowSelectStartDateType: 1,
      // 结束时间选中的时间类型
      nowSelectEndDateType: 1,



      // 开始时间选中的时段类型
      nowSelectStartTimeType: '',
      // 结束时间选中的时段类型
      nowSelectEndTimeType: '',


      // 开始时间选中的时段开始或结束时间
      startSelectTimeType: '',
      endSelectTimeType: '',



      // 时间列表
      timeArr: [],

      // 加载开始日期
      startLoadingDate: moment(),

      // 时间选择列表加载
      loading: false,
      finished: false,

      // 下拉刷新
      prevLoading: false,

      // 设置时间选择范围
      minHour: 0,
      maxHour: 23,
      minMinute: 0,
      maxMinute: 59
    };
  },
  computed: {

  },
  watch: {
    show(newVal, oldVal) {
      if (newVal) {
        this.getTimeTypeDate()
      }
    },
    nowSelectDate(newVal) {
      this.filterTime()
    }
  },
  methods: {
    // 设置时间选择器高度

    open(data) {
      console.log('data', data)
      // 回显数据
      this.nowSelectStartDate = data.startDate
      this.nowSelectStartTime = data.startTime
      this.nowSelectEndDate = data.endDate || moment(data.startDate, 'YYYY年MM月DD日').add(1, 'days').format('YYYY年MM月DD日')
      this.nowSelectEndTime = data.endTime || data.startTime
      this.nowSelectStartDateType = data.startDateType
      this.nowSelectEndDateType = data.endDateType

      this.nowSelectStartTimeType = data.startTimeType
      this.nowSelectEndTimeType = data.endTimeType
      this.startSelectTimeType = data.startSelectTimeType
      this.endSelectTimeType = data.endSelectTimeType

      // 设置当前时间
      this.startLoadingDate = moment(`${data.startDate} ${data.startTime}`, 'YYYY年MM月DD日 HH:mm')


      // 选中时段或自定义
      if (data.type == 1) {
        this.dateChangeType = data.startDateType
      } else if (data.type == 2) {
        this.dateChangeType = data.endDateType || data.startDateType
      }


      if (data.type == 1) {
        this.selectTimeType = this.nowSelectStartTimeType
      } else {
        this.selectTimeType = this.nowSelectEndTimeType
      }

      this.type = data.type
      this.show = true;
      if (data.type == 1) {
        this.currentTime = data.startTime
      } else if (data.type == 2) {
        this.currentTime = data.endTime || data.startTime
      }
      if (data.type == 1) {
        this.nowSelectDate = moment(data.startDate, 'YYYY年MM月DD日')
      } else if (data.type == 2) {
        this.nowSelectDate = data.endDate ? moment(data.endDate, 'YYYY年MM月DD日') : moment(data.startDate, 'YYYY年MM月DD日').add(1, 'days')
      }
      this.getDateList()
    },



    // 判断是否选中
    isChecked(time) {
      if (this.type == 1) {
        return this.nowSelectStartTime  == moment(time,'HH:mm:ss').format('HH:mm')
      } else if (this.type == 2) {
        return this.nowSelectEndTime  == moment(time,'HH:mm:ss').format('HH:mm')
      }
    },



    // 时间选择根据老师和宿管区分是否禁选
    filterTime() {
      let date = this.nowSelectDate
      if (this.identity === 'teacher') {
        // 判断是否是当天
        if (moment().format('YYYY年MM月DD日') == date.format('YYYY年MM月DD日')) { // 当天 - 时间选择只能选当前时间之后的时间
          this.minHour = moment().format('HH')
          this.minMinute = moment().format('mm')
        } else {
          this.minHour = 0
          this.minMinute = 0
        }
      }
    },





    // 获取当前时间及之后10天的时间
    getDateList() {
      let arr = []
      for (let i = this.timeArr.length ? 1 : 0; i <= 9; i++) {
        arr.push(this.startLoadingDate.clone().add(i, 'days'))
      }
      this.timeArr = [...this.timeArr, ...arr]
      this.startLoadingDate = this.timeArr[this.timeArr.length - 1]
    },

    // 下拉刷新 获取当前最早时间的前10天
    getPrevDateList() {
      let arr = []
      for (let i = 10; i >= 1; i--) {
        arr.push(this.timeArr[0].clone().subtract(i, 'days'))
      }
      this.timeArr = [...arr, ...this.timeArr]
      console.log('this.timeArr', this.timeArr)
      this.startLoadingDate = this.timeArr[this.timeArr.length - 1]
      this.prevLoading = false
    },







    changeType(type) {
      this.dateChangeType = type
      if (this.type == 1) {
        this.nowSelectStartDateType = this.dateChangeType
      } else if (this.type == 2) {
        this.nowSelectEndDateType = this.dateChangeType
      }

      if (this.dateChangeType == 1) { // 选择时段
        if (this.type == 1 && this.nowSelectStartTimeType) {
          this.selectTimeType = this.nowSelectStartTimeType
        } else if (this.type == 2 && this.nowSelectEndTimeType) {
          this.selectTimeType = this.nowSelectEndTimeType
        }
      }
      if (this.dateChangeType == 2) {
        if (this.type == 1 && !this.nowSelectStartTime) {
          this.nowSelectStartTime = this.currentTime
        } else if (this.type == 1 && this.nowSelectStartTime) {
          this.currentTime = this.nowSelectStartTime
        } else if (this.type == 2 && !this.nowSelectEndTime) {
          this.nowSelectEndTime = this.currentTime
        } else if (this.type == 2 && this.nowSelectEndTime) {
          this.currentTime = this.nowSelectEndTime
        }
      }

    },
    // 右侧时段时间
    getDate(date) {
      return moment(date, 'HH:mm:ss').format('HH:mm')
    },
    // 左侧列表时间
    getListDate(date) {
      if (moment().format('YYYY-MM-DD') == date.format('YYYY-MM-DD')) {
        return `今日 ${date.format('DD日')}`
      } else if (moment().clone().add(1, 'days').format('YYYY-MM-DD') == date.format('YYYY-MM-DD')) {
        return `明日 ${date.format('DD日')}`
      } else {
        return `${date.format('DD日')}`
      }
    },

    // 获取时间
    getMomentDate(date) {
      return date.format('YYYY-MM-DD')
    },
    // 获取年月时间
    getMonthDate(date) {
      return date.format('YYYY年MM月DD日')
    },

    // 右侧选择时间
    handleDatePicker() {
      console.log('date', this.currentTime)

      if (this.type == 1) {
        this.nowSelectStartTime = this.currentTime
        this.selectTimeType = ''
        this.nowSelectStartTimeType = ''
      } else {
        this.nowSelectEndTime = this.currentTime
        this.selectTimeType = ''
        this.nowSelectEndTimeType = ''
      }


    },
    // 获取当前时段
    getTimeTypeDate() {
      if (this.selectFloor) {
        this.$https.findDormTimeIntervalData({
          dormId: this.selectFloor,
        }).then(res => {
          let arr = []

          res.data.forEach(item => {
            if (arr.length == 0) {
              arr.push(item)
            } else {
              if (arr.find(x => x.timeType == item.timeType)) {

              } else {
                arr.push(item)
              }
            }
          })


          this.timeTypeList = arr
        })
      } else {
        this.$https.findDormTimeIntervalData({}).then(res => {
          console.log('res', res)
          // 筛选全部的宿舍考勤时段
          let oneType = []
          let twoType = []
          let threeType = []
          let fourType = []
          let totalType = []
          res.data.forEach(item => {
            if (item.timeType == 1) {
              oneType.push(item)
            } else if (item.timeType == 2) {
              twoType.push(item)
            } else if (item.timeType == 3) {
              threeType.push(item)
            } else if (item.timeType == 4) {
              fourType.push(item)
            }
          })
          totalType.push(oneType.reduce((earliest, current) => {
            return current.startTime < earliest.startTime ? current : earliest;
          }, oneType[0]))
          totalType.push(twoType.reduce((earliest, current) => {
            return current.startTime < earliest.startTime ? current : earliest;
          }, twoType[0]))
          totalType.push(threeType.reduce((earliest, current) => {
            return current.startTime < earliest.startTime ? current : earliest;
          }, threeType[0]))
          totalType.push(fourType.reduce((earliest, current) => {
            return current.startTime < earliest.startTime ? current : earliest;
          }, fourType[0]))

          this.timeTypeList = totalType
        })
      }
    },
    closePop() {
      this.show = false;
    },

    // 选择左侧日期
    selectDate(date) {
      this.nowSelectDate = date
      if (this.type == 1) {
        this.nowSelectStartDate = this.getMonthDate(this.nowSelectDate)
      } else {
        this.nowSelectEndDate = this.getMonthDate(this.nowSelectDate)
      }
    },


    // 切换开始和结束时间
    changeStartEndDate(type) {
      this.type = type;
      if (this.type == 1) {
        // 列表选中时间赋值
        if (this.nowSelectStartDate) {
          this.nowSelectDate = moment(this.nowSelectStartDate, 'YYYY年MM月DD日')
        } else {
          this.nowSelectDate = ''
        }

        // 时间类型赋值
        if (this.nowSelectStartDateType) {
          this.dateChangeType = this.nowSelectStartDateType
        }




        if (this.dateChangeType == 2 && this.nowSelectStartTime) {
          this.currentTime = this.nowSelectStartTime
        }

        if (this.dateChangeType == 1 && this.nowSelectStartTimeType) {
          this.selectTimeType = this.nowSelectStartTimeType
        } else if (this.dateChangeType == 1 && !this.nowSelectStartTimeType) { // 选择时段类型但未选择时段值
          this.selectTimeType = ''
          if (this.nowSelectStartTime) {
            this.dateChangeType = 2
            this.nowSelectStartDateType = 2
            if (this.nowSelectStartTime) {
              this.currentTime = this.nowSelectStartTime
            }
          }

        }

      } else if (this.type == 2) {



        // 列表选中时间赋值
        if (this.nowSelectEndDate) {
          this.nowSelectDate = moment(this.nowSelectEndDate, 'YYYY年MM月DD日')
        } else {
          if (this.nowSelectStartDate) {

            // 设置默认选中的结束日期
            this.nowSelectDate = moment(this.nowSelectStartDate, 'YYYY年MM月DD日').add(1, 'days')
            this.nowSelectEndDate = moment(this.nowSelectStartDate, 'YYYY年MM月DD日').add(1, 'days').format('YYYY年MM月DD日')
          } else {
            this.nowSelectDate = ''
          }
        }

        if (this.nowSelectEndTime) {
          this.currentTime = this.nowSelectEndTime
        } else if (this.nowSelectStartTime) {
          this.nowSelectEndTime = this.nowSelectStartTime
          this.currentTime = this.nowSelectStartTime
        }

        if (!this.nowSelectEndDateType) {
          this.nowSelectEndDateType = this.nowSelectStartDateType
        }






        // 时间类型赋值
        if (this.nowSelectEndDateType) {
          this.dateChangeType = this.nowSelectEndDateType
        }
        if (this.dateChangeType == 2 && this.nowSelectEndTime) {
          this.currentTime = this.nowSelectEndTime
        }


        if (this.dateChangeType == 1 && this.nowSelectEndTimeType) {
          this.selectTimeType = this.nowSelectEndTimeType
        } else if (this.dateChangeType == 1 && !this.nowSelectEndTimeType) {
          this.selectTimeType = ''
          if (this.nowSelectEndTime) {
            this.dateChangeType = 2
            this.nowSelectEndDateType = 2
            if (this.nowSelectEndTime) {
              this.currentTime = this.nowSelectEndTime
            }
          }

        }
      }
    },

    // 选择时段的开始时间
    handleStartTimetype(data) {
      console.log('datastart', data)
      if (this.type == 1) { // 开始时间
        this.nowSelectStartTime = moment(data.startTime, 'HH:mm:ss').format('HH:mm')
        this.nowSelectStartTimeType = data.timeType
        this.selectTimeType = data.timeType
        this.startSelectTimeType = 'start'


      } else if (this.type == 2) {
        this.nowSelectEndTime = moment(data.startTime, 'HH:mm:ss').format('HH:mm')
        this.nowSelectEndTimeType = data.timeType
        this.selectTimeType = data.timeType
        this.endSelectTimeType = 'start'
      }
    },


    // 选择时段的结束时间
    handleEndTimetype(data) {
      console.log('dataend', data)
      if (this.type == 1) { // 开始时间
        this.nowSelectStartTime = moment(data.endTime, 'HH:mm:ss').format('HH:mm')
        this.nowSelectStartTimeType = data.timeType
        this.selectTimeType = data.timeType
        this.startSelectTimeType = 'end'

      } else if (this.type == 2) {
        this.nowSelectEndTime = moment(data.endTime, 'HH:mm:ss').format('HH:mm')
        this.nowSelectEndTimeType = data.timeType
        this.selectTimeType = data.timeType
        this.endSelectTimeType = 'end'

      }
    },

    // 点击确定保存时间
    handleConfirm() {

      // 判断当前所处的是开始时间还是结束时间

      // 判断开始时间和结束时间是否都已输入完成
      if (this.nowSelectStartDate && this.nowSelectEndDate && this.nowSelectStartTime && this.nowSelectEndTime) {
        this.$emit('getLeaveDateInfo', {
          startDateType: this.nowSelectStartDateType, // 开始时间类型
          startTimeType: this.nowSelectStartTimeType, //开始时间时段
          startDate: this.nowSelectStartDate, // 开始时间日期
          startTime: this.nowSelectStartTime, // 开始时间时分
          startSelectTimeType: this.startSelectTimeType,
          endSelectTimeType: this.endSelectTimeType,
          endDateType: this.nowSelectEndDateType, // 开始时间类型
          endTimeType: this.nowSelectEndTimeType, //开始时间时段
          endDate: this.nowSelectEndDate, // 开始时间日期
          endTime: this.nowSelectEndTime // 开始时间时分
        })
        this.show = false
      } else {
        if (this.type == 1) {
          this.changeStartEndDate(2)
        } else {
          this.$emit('getLeaveDateInfo', {
            startDateType: this.nowSelectStartDateType, // 开始时间类型
            startTimeType: this.nowSelectStartTimeType, //开始时间时段
            startDate: this.nowSelectStartDate, // 开始时间日期
            startTime: this.nowSelectStartTime, // 开始时间时分
            startSelectTimeType: this.startSelectTimeType,
            endSelectTimeType: this.endSelectTimeType,
            endDateType: this.nowSelectEndDateType, // 开始时间类型
            endTimeType: this.nowSelectEndTimeType, //开始时间时段
            endDate: this.nowSelectEndDate, // 开始时间日期
            endTime: this.nowSelectEndTime // 开始时间时分
          })
          this.show = false
        }
      }
    },


    // 时间加载
    onLoad() {
      // 进行当前日期的更新
      setTimeout(() => {
        this.getDateList()
        // 加载状态结束
        this.loading = false;
      }, 1000);
    }

  }
};
</script>

<style lang="scss" scoped>
.pop_title {
  padding: .9014rem 1.2019rem 0;
  display: flex;
  justify-content: space-between;

  .title_close {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: .9615rem;
    color: #999999;
    line-height: 1.262rem;
    text-align: center;
    font-style: normal;

  }

  .title_center {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: .9615rem;
    color: #333333;
    line-height: 1.262rem;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }

  .title_confirm {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: .9615rem;
    color: #333333;
    line-height: 1.262rem;
    text-align: center;
    font-style: normal;
  }

}

.pop_tabs {
  margin: 0 .7212rem;

  display: flex;
  border-bottom: .0601rem solid #E8E8E8;

  .pop_tabs_item {
    position: relative;
    padding: 1.1418rem 0;
    flex: 1;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: .8413rem;
    color: #666666;
    line-height: 1.1418rem;
    text-align: center;
    font-style: normal;

    .tabs_item_title {
      margin-bottom: .4808rem;
    }
  }

  .pop_tabs_item_active {
    color: #3775FF;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      width: 1.5625rem;
      height: .1202rem;
      bottom: 0;
      left: 50%;
      background-color: #3775FF;
      transform: translateX(-50%);
    }
  }

}

.date_change {
  display: flex;

  .date_change_left {
    width: 7.8125rem;
    height: 14.4231rem;
    overflow-y: auto;

    .left_item {
      padding: .9014rem 0 .9014rem .7212rem;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: .8413rem;
      color: #666666;
      line-height: 1.1418rem;
      text-align: left;
      background-color: #F6F9FC;
      font-style: normal;
    }

    .left_item_active {
      color: #3775FF;
      background-color: #fff;
    }
  }

  .date_change_right {
    flex: 1;
    display: flex;
    padding: 0 .9615rem;
    flex-direction: column;

    .date_change_type {
      padding: .7813rem 0;
      display: flex;
      justify-content: space-around;

      .type_checkbox {
        .dorm-name-right-check {
          ::v-deep.van-checkbox__icon {
            .van-icon {
              border-radius: .1203rem;
              border: .0601rem solid #E8E8E8;
            }

          }

          ::v-deep.van-checkbox__label {
            margin-left: .3608rem;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: .8413rem;
            color: #666666;
            line-height: 1.1418rem;
            text-align: left;
            font-style: normal;
          }
        }
      }
    }

    .date_change_timeList {
      height: 11.7788rem;
      display: flex;
      overflow-y: auto;
      box-sizing: border-box;
      flex-direction: column;

      .typeList_item {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: .8413rem;
        color: #666666;
        line-height: 1.1418rem;
        text-align: left;
        font-style: normal;
        margin-bottom: 1.5625rem;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .custom-checkbox {
          ::v-deep .van-checkbox__icon--checked .van-icon {
            color: #fff;
            background-color: #1989fa;
            border-color: #1989fa;
          }
        }
      }

      .typeList_item_active {
        color: #3775FF;
      }

      .van-datetime-picker {
        height: 100%;
      }

      // 设置时间选择器的样式
      .datetime_picker {
        ::v-deep.van-picker__columns .van-picker-column__wrapper .van-ellipsis {
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: .8413rem;
          color: #666666;
          line-height: 1.1418rem;
          text-align: center;
          font-style: normal;
        }

        ::v-deep.van-picker__columns .van-picker-column__wrapper .van-picker-column__item--selected .van-ellipsis {
          color: #3775FF;
        }

        ::v-deep .van-picker__columns .van-picker__frame {
          background: #3775FF;
          border-radius: .2404rem;
          opacity: 0.1;
        }

        ::v-deep .van-picker__columns {
          margin-top: -2.3438rem;
        }
      }

    }

  }
}
</style>